module.exports = "/to_the_arctic_for_practice/_next/static/videos/16_2-cdb660347696a46a0da2933db692b739.mp4";